var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestful(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0229 8.17698C17.9035 7.92569 17.6504 7.7666 17.372 7.7666H13.7563V9.21288H15.8679L13.9154 11.6535C13.666 11.9644 13.7166 12.42 14.0275 12.6695C14.1559 12.7725 14.315 12.8286 14.4795 12.8286H18.0952V11.3823H15.9836L17.9361 8.9417C18.1096 8.72476 18.144 8.42827 18.0229 8.17698Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25879 12.1031H10.1929L7.39438 16.0142C7.16117 16.339 7.23709 16.7884 7.5607 17.0213C7.68363 17.1097 7.83007 17.1566 7.98193 17.1566H12.3207V15.7127H9.38662L12.1852 11.8016C12.4184 11.4768 12.3424 11.0274 12.0188 10.7945C11.8959 10.7061 11.7495 10.6592 11.5976 10.6592H7.25879V12.1031Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3293 5.60791L9.72732 6.81014L8.52148 7.41036L9.72732 8.01057L10.3293 9.2128L10.9313 8.01057L12.1372 7.41036L10.9313 6.81014L10.3293 5.60791Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3857 16.6172C15.7851 16.6172 16.1089 16.2934 16.1089 15.894C16.1089 15.4947 15.7851 15.1709 15.3857 15.1709C14.9864 15.1709 14.6626 15.4947 14.6626 15.894C14.6626 16.2934 14.9864 16.6172 15.3857 16.6172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestful);
export default __webpack_public_path__ + "static/media/restful.3213244d65734ac6f9036a335df68253.svg";
export { ForwardRef as ReactComponent };